import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { toast } from "react-toastify";
import { reduxForm } from 'redux-form';
import PlaidControl from './../../../components/PlaidControl';
import { integratePlaid, getPlaidAccounts, setBankAccount, resetFlags } from '../../../redux/actions/AccountAction';

const SelectBankAccount = ({
  nextStep,
  prevStep,
  active,
  integratePlaid,
  getPlaidAccounts,
  setBankAccount,
  resetFlags,
  accountErrors,
  accountFlags,
  investAccount,
  plaidAccounts,
  hasPlaidAccountConnected,
}) => {
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    if (accountErrors && accountErrors.integratePlaid) {
      toast.error(accountErrors.integratePlaid);
      setProcessing(false);
      resetFlags();
    }

    if (accountFlags && accountFlags.integratePlaidSuccess) {
      resetFlags();
      setProcessing(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountErrors, accountFlags]);

  const handleOnSuccess = (token, metadata) => {
    const payload = {
      public_token: token,
      bank_name: metadata.institution.name,
      invest_account_id: investAccount.id,
    }
    setProcessing(true);
    integratePlaid(payload, onConnectSuccess);
  }

  const onConnectSuccess = () => {
    getPlaidAccounts({ id: investAccount.id }, onGetAccountsSuccess);
  }

  const onGetAccountsSuccess = () => {
    setProcessing(false);
  };

  const handleOnExit = () => {
    // handle the case when your user exits Link
  }

  const handleBack = () => {
    prevStep(hasPlaidAccountConnected ? 1 : 0);
  };

  const handleNext = (account) => {
    setBankAccount(account);
    nextStep();
  };

  return (
    <div className={`account-setup-wrapper ${!active ? 'd-none' : ''}`}>
      <div className="form-container">
        <div className="back-btn">
          <Button color="link" onClick={handleBack}>back</Button>
        </div>
        <div className="form-header mt-md-3 mt-0">
          <h2>FUND YOUR ACCOUNT</h2>
          <span>Select an account to fund your new account</span>
        </div>

        <div className="account-info-container">
          {plaidAccounts && plaidAccounts.length && plaidAccounts.map((account, index) => (
            <div key={index} className="select_account mb-2" onClick={() => handleNext(account)}>
              <div className="account_heading">
                <h5>{account.name}</h5>
                <h6>{account.type}</h6>
              </div>
              <div className="acc_price">
                <h5>${account.available_balance}</h5>
                {/* <span>6 seconds ago</span> */}
              </div>
            </div>
          ))}
        </div>

        <div className="button_wrapper plaid_wrapper">
          <PlaidControl
            onExit={handleOnExit}
            onSuccess={handleOnSuccess}
            processing={processing}
            title="LINK ANOTHER BANK ACCOUNT"
          />
        </div>
      </div>
    </div >
  )
};

const mapStateToProps = state => ({
  accountErrors: state.Account.errors,
  accountFlags: state.Account.flags,
  investAccount: state.Account.investAccount,
  plaidAccounts: state.Account.plaidAccounts,
});

const mapDispatchToProps = dispatch => ({
  integratePlaid: (payload, callback) => {
    dispatch(integratePlaid(payload, callback))
  },
  getPlaidAccounts: (payload, callback) => {
    dispatch(getPlaidAccounts(payload, callback))
  },
  setBankAccount: payload => {
    dispatch(setBankAccount(payload))
  },
  resetFlags: payload => {
    dispatch(resetFlags())
  }
});

const SelectBankAccountComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectBankAccount);

export default reduxForm({
  form: 'SelectBankAccountForm',
})(SelectBankAccountComponent);
